import type { OrderStatus, StageStatus } from '@/api/types'
import { orderStatusLabel, stageStatusLabel } from '@/i18n/labels'
import { Chip } from './Chip'
import { cn } from './cn'

const orderTone: Record<OrderStatus, string> = {
  DRAFT: 'bg-black/5 text-tg-hint',
  PLANNED: 'bg-blue-100 text-blue-800',
  IN_PRODUCTION: 'bg-indigo-100 text-indigo-800',
  PAUSED: 'bg-amber-100 text-amber-800',
  READY: 'bg-green-100 text-green-800',
  SHIPPED: 'bg-emerald-100 text-emerald-900',
  CANCELLED: 'bg-red-100 text-red-800',
}

export function OrderStatusChip({ status }: { status: OrderStatus }) {
  return <Chip className={cn(orderTone[status])}>{orderStatusLabel[status]}</Chip>
}

const stageTone: Record<StageStatus, string> = {
  PENDING: 'bg-black/5 text-tg-hint',
  AVAILABLE: 'bg-blue-100 text-blue-800',
  ACCEPTED: 'bg-sky-100 text-sky-800',
  IN_PROGRESS: 'bg-indigo-100 text-indigo-800',
  PAUSED: 'bg-amber-100 text-amber-800',
  COMPLETED: 'bg-green-100 text-green-800',
  TRANSFERRED: 'bg-emerald-100 text-emerald-900',
  SKIPPED: 'bg-zinc-200 text-zinc-700',
  CANCELLED: 'bg-red-100 text-red-800',
}

export function StageStatusChip({ status }: { status: StageStatus }) {
  return <Chip className={cn(stageTone[status])}>{stageStatusLabel[status]}</Chip>
}
